import React from 'react'
import checkCircle from '../../assets/img/icons/check-circle.svg'
import type { ActiveBadgeProps } from './types'

const ACTIVE_TEXT = 'ACTIVE'
const INACTIVE_TEXT = 'INACTIVE'

const ActiveBadge = ({ isActive = false, zoom = 1 }: ActiveBadgeProps) => {
  const containerStyle = {
    backgroundColor: isActive ? '#087B45' : '#486CD8',
    transform: `scale(${zoom})`,
  }

  return (
    <div className="active-badge" style={containerStyle}>
      {isActive && <img src={checkCircle} />}
      <p className="active-badge__text">
        {isActive ? ACTIVE_TEXT : INACTIVE_TEXT}
      </p>
    </div>
  )
}

export default ActiveBadge
